import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BookingReferences } from 'src/app/model/page/sandbox-page';
import { CancelGetRefundReshopRQ } from 'src/app/model/request/cancel-get-refund-order-reshop-screen-request';
import { FindOrderScreenRequest } from 'src/app/model/request/find-order-screen-request';
import { OCNMessageRequest } from 'src/app/model/request/ocn-message-operator-request';
import { OfferPriceScreenOrderCreateRequest } from 'src/app/model/request/offer-price-screen-order-create-request';
import { OrderChangeAccept } from 'src/app/model/request/order-change-accept-screen-request';
import { Passenger as primeSalePassenger, PrimeSaleAddBaggageRequest } from 'src/app/model/request/prime-sale-add-baggae';
import { OrderReshopRequoteScreenRQ, Passenger as ReQuotePassenger } from 'src/app/model/request/requote-request-screeen';
import { AddAncilliariesScreen } from 'src/app/model/screen/add-ancilliaries-screen';
import { CancelBookingGetRefundScreen } from 'src/app/model/screen/cancel-booking-get-refund';
import { CancelBookingGetRefundDetails, HeldBookingIssueTicketDetails, HeldBookingReQuoteTicketDetails } from 'src/app/model/screen/confirm-booking-screen';
import { FindOrdersScreen } from 'src/app/model/screen/find-order-screen';
import { ChangeDatetimeReshopReprice } from 'src/app/model/request/change-date-time-reshop-reprice-request';
import { Passenger as passengerDetailScreenPassenger, Passenger as PassengerScreenPassenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import findOrderJSON from 'src/assets/json/find-order/request/find-order-default-params.json';
import reQuoteOrderJSON from 'src/assets/json/order-reshop/requote/request/requote-request-default-params.json';

@Component({
  selector: 'app-find-order-screen',
  templateUrl: './find-order-screen.component.html',
  styleUrls: ['./find-order-screen.component.scss']
})
export class FindOrderScreenComponent implements OnInit, OnDestroy {
  yourBookingScreen: YourBookingScreen = {} as YourBookingScreen;

  orderReshopRequoteScreenRQ: OrderReshopRequoteScreenRQ = {} as OrderReshopRequoteScreenRQ;

  ocnMessageOperatorRequest = {} as OCNMessageRequest;

  issueTicketConfirmBookingPageDetails = {} as HeldBookingIssueTicketDetails;
  reQuoteTicketConfirmBookingPageDetails = {} as HeldBookingReQuoteTicketDetails;

  cancelBookingGetRefundScreenRQ = {} as CancelGetRefundReshopRQ;

  cancelBookingPageDetails = {} as CancelBookingGetRefundDetails;
  cancelBookingGetRefundScreen = {} as CancelBookingGetRefundScreen;
  cancelBookingRefundData: any;

  acceptChangeBookingScreenRQ = {} as OrderChangeAccept;

  offerPriceScreenServiceListRequest: PrimeSaleAddBaggageRequest = {} as PrimeSaleAddBaggageRequest;

  isSMEUser: boolean = false;

  constructor(
    private apiService: ApiService,
    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private sandboxPageStateService: SandboxPageStateService,
    private formBuilder: FormBuilder,
    private http: HttpClient
  ) {
    Object.entries(findOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.inputParamsMap.set(key, value);
    });
    Object.entries(reQuoteOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.reQuoteInputParamsMap.set(key, value);
    });
  }

  inputParamsMap = new Map();
  reQuoteInputParamsMap = new Map();
  findOrderScreenRequest: FindOrderScreenRequest = {} as FindOrderScreenRequest;

  findOrderForm: any = 1;
  bookingReferences: BookingReferences = {} as BookingReferences;

  reQuoteRequestType: 'issueTicket' | 'reQuoteTicket' = 'issueTicket';

  findOrdersScreen: FindOrdersScreen = {} as FindOrdersScreen;

  isYourBookingMapped?: boolean;
  isYourBookingStatus?: string;
  isSearchRequestGenerated: boolean = false;

  selectedPNR: any;
  loggeduserMailID: any;
  apiResponse: Response = {} as Response;

  //ocn message
  haveOcnNotificationDetail: boolean = false;
  current_timestamp: any = null;
  //end
  ngOnInit() {
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
    this.loggeduserMailID = this.sandboxPageStateService.getEncodedUserEmail();
    this.selectedPNR = this.sandboxPageStateService.getFindOrderFormValue();
    this.findOrderForm = this.initFindOrderForm();
    this.yourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
    //check for ocn notification pnr
    if (findOrderScreenData.haveOcnNotificationDetail === true) {
      this.findOrderForm.patchValue({
        pnrNumber: findOrderScreenData.pnr
      });
      this.haveOcnNotificationDetail = findOrderScreenData.haveOcnNotificationDetail;
      this.current_timestamp = findOrderScreenData.current_timestamp;
      this.selectedPNR = findOrderScreenData.pnr;
      this.searchOrder();
    }
    if (findOrderScreenData.isOrderDetailsTriggered) {
      this.findOrderForm.patchValue({
        pnrNumber: findOrderScreenData.pnr
      });
      findOrderScreenData.isOrderDetailsTriggered = false;
      this.selectedPNR = findOrderScreenData.pnr;
      this.searchOrder();
    }
    //end
    this.sandboxPageStateService.sandboxScreenDataSource.subscribe((sandboxScreenData: any) => {
      if (sandboxScreenData.findOrdersScreen && sandboxScreenData.findOrdersScreen.isYourBookingMapped) {
        this.findOrdersScreen = sandboxScreenData.findOrdersScreen;
        this.isYourBookingMapped = this.findOrdersScreen.isYourBookingMapped;
        this.isYourBookingStatus = this.findOrdersScreen.isYourBookingStatus;
      }

      if (sandboxScreenData.bookingReferences && sandboxScreenData.bookingReferences.pnrNumbers) {
        if (sandboxScreenData.findOrderFormValue) {
          this.findOrderForm.controls['pnrNumber'].setValue(sandboxScreenData.findOrderFormValue);
        }
        this.bookingReferences = this.sandboxPageStateService.getBookingReferences();
        this.findOrderForm.controls['selectedPNRNumber'].setValue(sandboxScreenData.findOrderFormValue);
      }
    });
  }

  addAncilliaries() {
    let addAnclilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    if (typeof addAnclilliariesScreenData === 'undefined') {
      addAnclilliariesScreenData = {} as AddAncilliariesScreen;
      addAnclilliariesScreenData.displayService = 'All';

      addAnclilliariesScreenData.xml = '';
      addAnclilliariesScreenData.json = '';
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);
    }

    if (!addAnclilliariesScreenData.isServiceRequestGenerate) {
      this.initServiceXMLRequest();
    } else {
      let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  async initServiceXMLRequest() {
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    let pnr = yourBookingScreenData.booking.pnrNumber;
    let owner = yourBookingScreenData.booking.bookingAgent;
    let carb = 'CARB';
    let includes = 'true';
    let findOrderScreenRequest = {} as FindOrderScreenRequest;
    let createOrderScreenRequest = {} as OfferPriceScreenOrderCreateRequest;
    let orderRepriceRequest = {} as ChangeDatetimeReshopReprice;
    if (yourBookingScreenData.bookingType === 'pre-booking') {
      let jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
      createOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (yourBookingScreenData.bookingType === 'post-booking') {
      let jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
      findOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (yourBookingScreenData.bookingType === 'post-booking-reshop') {
      let jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.CHANGE_BOOKING_ORDER_REPRICE_URL);
      orderRepriceRequest = JSON.parse(jsonRequest);
    }
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.PRIME_BAG_SERVICE_REQUEST_TEMPLATE);
    this.offerPriceScreenServiceListRequest = JSON.parse(jsonRequestTemplate as any);
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$.Version = '17.2';
    if (yourBookingScreenData.bookingType === 'pre-booking') {
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Document = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Document;
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Party = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Party;
    } else if (yourBookingScreenData.bookingType === 'post-booking') {
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Document = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Document;
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Party = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Party;
    } else if (yourBookingScreenData.bookingType === 'post-booking-reshop') {
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Document = orderRepriceRequest['S:Envelope']['S:Body']?.OrderReshopRQ.Document;
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Party = orderRepriceRequest['S:Envelope']['S:Body']?.OrderReshopRQ.Party;
    }
    delete this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.ShoppingResponseID;
    delete this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Query.Offers;
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Query.OrderID = {
      $: {
        Owner: owner
      },
      _: pnr
    };
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.DataLists.PassengerList.Passenger = [];
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.DataLists.PassengerList.Passenger = this.loadServicePassenger();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL, JSON.stringify(this.offerPriceScreenServiceListRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'ServiceList17_2_V1'
      }),
      responseType: 'text'
    });
    this.updateAddAncilliariesResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL);
  }
  updateAddAncilliariesResponse(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let addServiceScreenDetail = this.sandboxPageStateService.getAddBaggageScreenDetail();
      addServiceScreenDetail.xml = this.sandboxPageStateService.getResponseFromMap(url);
      addServiceScreenDetail.jsonData = this.xmlToJsonParserService.parseXMLToJSON(addServiceScreenDetail.xml);
      addServiceScreenDetail.bookingType = 'your-booking-screen-add-ancilliaries';
      this.sandboxPageStateService.updateAddBaggageScreenDetail(addServiceScreenDetail);
      let addAnclilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
      addAnclilliariesScreenData.isServiceRequestGenerate = true;
      addAnclilliariesScreenData.displayService = 'All';
      addAnclilliariesScreenData.selectedOfferId = '';
      addAnclilliariesScreenData.selectedOfferItem = [];
      addAnclilliariesScreenData.selectedOwner = '';
      addAnclilliariesScreenData.currency = '';
      addAnclilliariesScreenData.selectedResponseId = '';

      addAnclilliariesScreenData.xml = addServiceScreenDetail.xml;
      addAnclilliariesScreenData.json = addServiceScreenDetail.jsonData;
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);

      let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }
  loadServicePassenger() {
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerRequestDetails: primeSalePassenger[] = [];
    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerDetail.forEach((passenger: PassengerScreenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail: primeSalePassenger = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };
        if (typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }
        passengerRequestDetails.push(passengerDetail);
      });
    }
    return passengerRequestDetails;
  }
  cancelTicket() {
    let patchSandboxSourceData = { mainMenu: 'none', showError: 'Yes', errorMessage: 'An error occurred while processing your request.' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  issueTicket() {
    this.reQuoteRequestType = 'issueTicket';
    this.initOrderReshopRequoteScreenRequest();
  }

  reQuoteTicket() {
    this.reQuoteRequestType = 'reQuoteTicket';
    this.initOrderReshopRequoteScreenRequest();
  }

  cancelBookingRefundOption() {
    this.initCancelBookingGetRefundScreenRequest();
    this.cancelBookingData();
  }
  cancelBookingIssueVoucher() { }
  // init Cancel Booking (Get Refund)
  async initCancelBookingGetRefundScreenRequest() {
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.CANCEL_BOOKING_GET_REFUND_REQUEST_TEMPLATE);
    this.cancelBookingGetRefundScreenRQ = JSON.parse(jsonRequestTemplate as any);
    let cancelBookingGetRefundDetail: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = cancelBookingGetRefundDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    this.cancelBookingGetRefundScreenRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelBookingGetRefundScreenRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.Version = '17.2';
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.OrderID = pnr;
    this.cancelBookingGetRefundScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Delete.OrderItem.$.OrderItemID = pnr;
    await this.apiService.getXMLResponse(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL, JSON.stringify(this.cancelBookingGetRefundScreenRQ), this.reQuoteInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderReshop17_2_V3'
      }),
      responseType: 'text'
    });
    this.updateCancelReQuoteXML(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL);
  }

  updateCancelReQuoteXML(url: any) {
    let patchSandboxSourceData: any = '';
    let reQuoteCancelRefundTicketXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let reQuoteCancelRefundTicketJSONData = this.xmlToJsonParserService.parseXMLToJSON(reQuoteCancelRefundTicketXMLData);
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      //  patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
      // this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let yourBookingPriceDetail = yourBookingScreenDetail.booking.priceDetail;

      let cancelBookingRefundScreen = this.sandboxPageStateService.getCancelBookingScreenData();
      cancelBookingRefundScreen.xml = reQuoteCancelRefundTicketXMLData;
      cancelBookingRefundScreen.jsonData = reQuoteCancelRefundTicketJSONData;
      if (reQuoteCancelRefundTicketJSONData['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].RESHOPOFFERS[0]) {
        let cancelPriceDetails = reQuoteCancelRefundTicketJSONData['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].RESHOPOFFERS[0].RESHOPOFFER[0].TOTALPRICE[0].SIMPLECURRENCYPRICE[0];
        let total = cancelPriceDetails._;
        let code = cancelPriceDetails.$.CODE;
        cancelBookingRefundScreen.priceDetail = {
          priceCode: code,
          totalCharge: total
        };
      } else {
        let total = '0';
        let code = yourBookingPriceDetail.currency;
        cancelBookingRefundScreen.priceDetail = {
          priceCode: code,
          totalCharge: total
        };
      }

      this.sandboxPageStateService.updateCancelBookingScreenData(cancelBookingRefundScreen);

      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.displayCancelGetRefundForm = true;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
      setTimeout(() => {
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        if (this.sandboxPageStateService.getWarningMessage() !== '') {
          patchSandboxSourceData['showWarning'] = 'Yes';
          patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
        }
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 100);
    }
  }

  acceptChangedDisruptedFilghts() {
    this.initOrderChangeAcceptScreenRequest();
  }
  async initOrderChangeAcceptScreenRequest() {
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ACCEPT_REQUEST_TEMPLATE);
    this.acceptChangeBookingScreenRQ = JSON.parse(jsonRequestTemplate as any);
    let yourBookingScreenData: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenData.booking;
    let orderID = bookingDetail.pnrNumber;
    let orderItemRefID: any[] = [];
    if (typeof bookingDetail.disruptedDetails.distruptedOrderItem !== 'undefined') {
      bookingDetail.disruptedDetails.distruptedOrderItem.forEach((order) => {
        orderItemRefID.push(order);
      });
    }
    this.acceptChangeBookingScreenRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.acceptChangeBookingScreenRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.acceptChangeBookingScreenRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.Query.OrderID = orderID;
    this.acceptChangeBookingScreenRQ['S:Envelope']['S:Body']!.OrderChangeRQ.AugmentationPoint.InvolChanges.AcceptChange.OrderItemRefID = orderItemRefID;
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.acceptChangeBookingScreenRQ), this.reQuoteInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateAcceptDisruptionXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
  }

  triggerOcnMessage(status: 'ACTIONED' | 'CANCELLED') {
    let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
    if (this.haveOcnNotificationDetail) {
      //this.initOCNMessageAPIRequest(findOrderScreenData.pnr,status);
      this.postUserInformation(status);
      // trigger api
      //trigger success
      findOrderScreenData.haveOcnNotificationDetail = false;
      this.sandboxPageStateService.updateFindOrderScreen(findOrderScreenData);
      this.haveOcnNotificationDetail = false;
      //trigger success end
      //trgger end
    }
  }

  async postUserInformation(status: 'ACTIONED' | 'CANCELLED') {
    let queryParams = new HttpParams();
    let body = [
      {
        pnr: this.selectedPNR,
        currentTimestamp: this.current_timestamp,
        changedBy: this.loggeduserMailID,
        userAction: status === 'ACTIONED' ? 'Accepted' : 'Cancelled'
      }
    ];
    await this.apiService.sendPostRequest(body, '/update-ocn-messages');
  }

  updateAcceptDisruptionXML(url: any) {
    let acceptDisruptionXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let acceptDisruptionJSONData = this.xmlToJsonParserService.parseXMLToJSON(acceptDisruptionXMLData);

    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let patchSandboxSourceData: any = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      let yourBookingScreenData: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.xml = acceptDisruptionXMLData;
      yourBookingScreenData.jsonData = acceptDisruptionJSONData;
      yourBookingScreenData.isMapped = false;
      this.triggerOcnMessage('ACTIONED');

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
      setTimeout(() => {
        let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 100);
    }
  }

  // init issue ticket function'
  async initOrderReshopRequoteScreenRequest() {
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.REQUOTE_REQUEST_TEMPLATE);
    this.orderReshopRequoteScreenRQ = JSON.parse(jsonRequestTemplate as any);
    let yourBookingScreenDetail: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let owner = bookingDetail?.bookingAgent;
    this.orderReshopRequoteScreenRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderReshopRequoteScreenRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderReshopRequoteScreenRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.Version = '17.2';
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.DataLists.PassengerList.Passenger = [];
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.Query.OrderID = pnr;
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.OrderKeys.OrderID._ = pnr;
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.OrderKeys.OrderID.$.Owner = owner;
    this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.PassengerReferences = '';
    this.loadPassengerDetail();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL, JSON.stringify(this.orderReshopRequoteScreenRQ), this.reQuoteInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderReshop17_2_V3'
      }),
      responseType: 'text'
    });
    this.updateReQuoteXML(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL);
  }

  updateReQuoteXML(url: string) {
    let reQuoteIssueTicketXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let reQuoteIssueTicketJSONData = this.xmlToJsonParserService.parseXMLToJSON(reQuoteIssueTicketXMLData);
    let findOrdersScreen: FindOrdersScreen = this.sandboxPageStateService.getFindOrderScreenData();
    findOrdersScreen.reQuoteXml = reQuoteIssueTicketXMLData;
    findOrdersScreen.reQuoteJson = reQuoteIssueTicketJSONData;
    this.sandboxPageStateService.updateFindOrderScreen(findOrdersScreen);
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      if (this.reQuoteRequestType === 'issueTicket') {
        this.mapissueTickedData(reQuoteIssueTicketJSONData);
      } else if (this.reQuoteRequestType === 'reQuoteTicket') {
        this.mapReQuoteTicketData(reQuoteIssueTicketJSONData);
      }
    }
  }

  mapReQuoteTicketData(reQuoteIssueTicketJSONData: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let issueTicketEnvelop = reQuoteIssueTicketJSONData['SOAP:ENVELOPE'];
      let issueTicketBody = issueTicketEnvelop['SOAP:BODY'][0];
      let issueTicketOrderShopViews = issueTicketBody['ORDERRESHOPRS'][0];
      let issueTicketOrderShopResponse = issueTicketOrderShopViews['RESPONSE'][0];

      let issueTickerReshopOffer = issueTicketOrderShopResponse['RESHOPOFFERS'][0]['RESHOPOFFER'];

      let responseId = issueTicketOrderShopResponse['RESHOPPINGRESPONSEID'][0]['RESPONSEID'][0];
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let pnrNumber = yourBookingScreenDetail.booking?.pnrNumber;
      this.reQuoteTicketConfirmBookingPageDetails = {
        OrderID: pnrNumber,
        ResponseID: responseId
      };

      let passengerScreenDetails = this.mapPassengerDetail(issueTickerReshopOffer);
      let passengerScreenData: PassengerDetailScreen = {
        bookingPassengerDetailType: 'your-booking-screen-passenger',
        isMapped: true,
        passengerDetail: passengerScreenDetails.passengerDetails,
        totalTax: passengerScreenDetails.totalTax,
        totalPrice: passengerScreenDetails.totalPrice,
        totalBasePrice: passengerScreenDetails.totalBasePrice,
        currency: passengerScreenDetails.currency,
        pnrNumber: pnrNumber,
        activePassengerIndex: 0
      };

      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.displayConfirmBookingForm = true;

      let confirmBookingScreen = this.sandboxPageStateService.getConfirmBookingScreenData();
      confirmBookingScreen.bookingType = 'post-booking-requote-ticket-form';
      confirmBookingScreen.heldBookingReQuoteTicketDetails = this.reQuoteTicketConfirmBookingPageDetails;

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
      this.sandboxPageStateService.updatePassengerDetailScreenData(passengerScreenData);
      this.sandboxPageStateService.updateConfirmBookingScreenData(confirmBookingScreen);

      let patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'find-orders-screen-requote-ticket' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  mapissueTickedData(reQuoteIssueTicketJSONData: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let issueTicketEnvelop = reQuoteIssueTicketJSONData['SOAP:ENVELOPE'];
      let issueTicketBody = issueTicketEnvelop['SOAP:BODY'][0];
      let issueTicketOrderShopViews = issueTicketBody['ORDERRESHOPRS'][0];
      let issueTicketOrderShopResponse = issueTicketOrderShopViews['RESPONSE'][0];
      let issueTickerReshopOffer = issueTicketOrderShopResponse['RESHOPOFFERS'][0]['RESHOPOFFER'];
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let pnrNumber = yourBookingScreenDetail.booking?.pnrNumber;
      let responseId = issueTicketOrderShopResponse['RESHOPPINGRESPONSEID'][0]['RESPONSEID'][0];
      let passengerScreenDetails = this.mapPassengerDetail(issueTickerReshopOffer);
      let passengerScreenData: PassengerDetailScreen = {
        bookingPassengerDetailType: 'your-booking-screen-passenger',
        isMapped: true,
        passengerDetail: passengerScreenDetails.passengerDetails,
        totalTax: passengerScreenDetails.totalTax,
        totalPrice: passengerScreenDetails.totalPrice,
        totalBasePrice: passengerScreenDetails.totalBasePrice,
        currency: passengerScreenDetails.currency,
        pnrNumber: pnrNumber,
        activePassengerIndex: 0
      };
      this.issueTicketConfirmBookingPageDetails = {
        OrderID: pnrNumber,
        ResponseID: responseId,
        priceDetails: {
          flightPrice: passengerScreenDetails.totFlightPtice,
          seatPrice: passengerScreenDetails.totSeatPrice,
          servicePrice: passengerScreenDetails.totSeatPrice,
          cardFee: '0',
          totalCharge: passengerScreenDetails.totalPrice,
          priceCode: passengerScreenDetails.currency
        }
      };

      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.displayConfirmBookingForm = true;

      let confirmBookingScreen = this.sandboxPageStateService.getConfirmBookingScreenData();
      confirmBookingScreen.bookingType = 'post-booking-issue-ticket-form';
      confirmBookingScreen.heldBookingIssueTicketDetails = this.issueTicketConfirmBookingPageDetails;

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
      this.sandboxPageStateService.updatePassengerDetailScreenData(passengerScreenData);
      this.sandboxPageStateService.updateConfirmBookingScreenData(confirmBookingScreen);

      patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'find-orders-screen-issue-ticket', showWarning: 'Yes', warningMessage: this.sandboxPageStateService.getWarningMessage() };

      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  mapPassengerDetail(reShopfferDetail: any) {
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let totalTax: any = 0;
    let totalPrice: any = 0;
    let totalBasePrice: any = 0;
    let totSeatPrice: any = 0;
    let totalFlightChg: any = 0;
    let currency = '';
    let passengerListLength = passengerDetail.length;
    if (passengerListLength > 0) {
      let passengerIndex = 0;
      passengerDetail.forEach((passenger: passengerDetailScreenPassenger) => {
        passenger.totalPrice = 0;
        passenger.basePrice = 0;
        passenger.taxPrice = 0;
        let totalPassengerPrice: any = 0;
        let totalPassengerBasePrice: any = 0;
        let totalPassengerTaxPrice: any = 0;
        let totalPassengerSeatPrice: any = 0;
        reShopfferDetail.forEach((offerItem: any) => {
          let addOfferItems = offerItem.ADDOFFERITEM;
          let addOfferItemLength = addOfferItems.length;
          if (addOfferItemLength > 0) {
            addOfferItems.forEach((addOfferItem: any) => {
              let serviceList = addOfferItem.SERVICE;
              let serviceListLength = serviceList.length;
              let ispriceAdded: boolean = false;
              if (serviceListLength > 0) {
                serviceList.forEach((service: any) => {
                  let passengerRef = service.PASSENGERREFS[0];
                  let passengerRefIndexArray = passengerRef.split(' ');
                  let isPassengerIdPresent: any = passengerRefIndexArray.indexOf(passenger.passengerId);
                  if (!ispriceAdded && isPassengerIdPresent !== -1 && isPassengerIdPresent !== '-1') {
                    ispriceAdded = true;
                    if (typeof addOfferItem.FAREDETAIL !== 'undefined') {
                      let priceDetail = addOfferItem.FAREDETAIL[0].PRICE[0];
                      totalPassengerPrice += +priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                      totalPassengerBasePrice += +priceDetail.BASEAMOUNT[0]._;
                      totalPassengerTaxPrice += +priceDetail.TAXES[0].TOTAL[0]._;
                      currency = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                      totalFlightChg += +priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                    } else {
                      if (typeof service.SELECTEDSEAT !== 'undefined') {
                        let priceDetail = addOfferItem.TOTALPRICEDETAIL[0];
                        totalPassengerSeatPrice += +priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                        totalPassengerPrice += +priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                        currency = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                      }
                    }
                  }
                });
              }
            });
          }
        });
        passenger.totalPrice = totalPassengerPrice;
        passenger.basePrice = totalPassengerBasePrice + totalPassengerSeatPrice;
        passenger.taxPrice = totalPassengerTaxPrice;
        totalTax += +passenger.taxPrice;
        totalPrice += +passenger.totalPrice;
        totalBasePrice += passenger.basePrice;
        totSeatPrice += +totalPassengerSeatPrice;
        if (passengerIndex === 0) {
          passenger.contactRef = 'contact-' + passenger.passengerId;
        }
        passengerIndex++;
      });
    }
    return {
      passengerDetails: passengerDetail,
      totalTax: totalTax.toFixed(2),
      totalPrice: totalPrice.toFixed(2),
      totalBasePrice: totalBasePrice,
      currency: currency,
      totSeatPrice: totSeatPrice.toFixed(2),
      totFlightPtice: totalFlightChg.toFixed(2)
    };
  }

  loadPassengerDetail() {
    let passengerRefNumber = '';
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerDetailScreenData();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength: any = passengerDetail?.length;
    if (passengerDetailLength > 0) {
      passengerDetail?.forEach((passenger: PassengerScreenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail: ReQuotePassenger = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };
        passengerRefNumber += ' ' + passengerId;
        this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ['DataLists']['PassengerList']['Passenger'].push(passengerDetail);
      });
      this.orderReshopRequoteScreenRQ['S:Envelope']['S:Body'].OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.PassengerReferences = passengerRefNumber.trim();
    }
  }
  //end
  changeDate() {
    let yourBookingData = this.sandboxPageStateService.getYourBookingScreenData();
    yourBookingData.pnrNumber = this.selectedPNR;
    yourBookingData.current_timestamp = this.current_timestamp;
    yourBookingData.haveOcnNotificationDetail = this.haveOcnNotificationDetail;
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingData);

    let patchSandboxSourceData = { mainMenu: 'change-date-time-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  cancelBookingData() {
    let yourBookingData = this.sandboxPageStateService.getYourBookingScreenData();
    yourBookingData.pnrNumber = this.selectedPNR;
    yourBookingData.current_timestamp = this.current_timestamp;
    yourBookingData.haveOcnNotificationDetail = this.haveOcnNotificationDetail;
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingData);

    let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  ChangePassengerName() {
    let patchSandboxSourceData = { mainMenu: 'passenger-name-change' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  splitBooking() {
    const passengerDetailScreenData: PassengerDetailScreen = this.sandboxPageStateService.getPassengerDetailScreenData();
    if (this.isPassengerGroupAB(passengerDetailScreenData)) {
      let patchSandboxSourceData = { mainMenu: 'split-booking' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      this.sandboxPageStateService.setErrorMessage('No Passengers to Split - Select 2 groups A/B');
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  isPassengerGroupAB(passengerDetailScreenData: any): boolean {
    return (
      passengerDetailScreenData.passengerBList &&
      passengerDetailScreenData.passengerBList.length > 0 &&
      passengerDetailScreenData.passengerDetail.length !== passengerDetailScreenData.passengerBList.length
    );
  }

  isPnrNumberInBookingReferences() {
    return (
      this.bookingReferences && this.bookingReferences.pnrNumbers && this.bookingReferences.pnrNumbers.length > 1 && this.bookingReferences.pnrNumbers.includes(this.findOrderForm.value.pnrNumber)
    );
  }

  async searchOrder(retainSplitBookingData?: boolean) {
    this.isSearchRequestGenerated = true;
    this.sandboxPageStateService.resetSandboxPage(true, retainSplitBookingData);
    let patchSandboxSourceData = { mainMenu: 'none' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    this.isYourBookingMapped = false;

    this.findOrderForm.markAllAsTouched();

    let pnrNumber = this.findOrderForm.value.pnrNumber;
    if (pnrNumber && pnrNumber.length > 0) {
      let jsonRequestTemplate = await this.localAssetReaderService.getContent('./assets/json/find-order/request/find-order-request-template.json');
      this.findOrderScreenRequest = JSON.parse(jsonRequestTemplate as any);
      this.findOrderScreenRequest['S:Envelope']['S:Body'].OrderRetrieveRQ.Query.Filters.OrderID._ = pnrNumber;
      await this.apiService.getXMLResponse(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL, JSON.stringify(this.findOrderScreenRequest), this.inputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderRetrieve17_2_V3',
          'content-type': 'text/xml;charset=ISO-8859-1'
        }),
        responseType: 'text'
      });
      this.updateFindOrderScreenXML(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
      this.sandboxPageStateService.widthChange70();
    }
  }

  updateFindOrderScreenXML(url: string) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { mainMenu: 'none', showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      this.yourBookingScreen = {} as YourBookingScreen;
      this.yourBookingScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      this.yourBookingScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(this.yourBookingScreen.xml!);
      this.yourBookingScreen.bookingType = 'post-booking';
      this.yourBookingScreen.actualBookingType = 'post-booking';
      this.yourBookingScreen.displayConfirmBookingForm = false;

      let order = this.yourBookingScreen.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0]['ORDERVIEWRS'][0]['RESPONSE'][0]['ORDER'][0];

      let pnrNumbers: string[] = [];

      order.BOOKINGREFERENCES[0].BOOKINGREFERENCE.forEach((bookingReference: { ID: string }) => {
        pnrNumbers.push(bookingReference.ID && bookingReference.ID[0]);
      });

      this.sandboxPageStateService.updateYourBookingScreenData(this.yourBookingScreen);

      this.sandboxPageStateService.resetAddAnclilliariesScreen();

      patchSandboxSourceData = {
        findOrderFormValue: this.findOrderForm.value.pnrNumber,
        bookingReferences: { pnrNumbers: pnrNumbers },
        mainMenu: 'your-booking-screen'
      };

      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
    this.isSearchRequestGenerated = false;
  }

  initFindOrderForm() {
    let searchPnrNumber: string = this.sandboxPageStateService.getFindOrderFormValue();

    if (!(searchPnrNumber && searchPnrNumber.length > 0)) {
      searchPnrNumber = '';
    }

    return this.formBuilder.group({
      pnrNumber: [searchPnrNumber, [Validators.required]],
      selectedPNRNumber: []
    });
  }

  setActivePNR(event: any) {
    this.findOrderForm.controls['pnrNumber'].setValue(event.target.value);
    this.sandboxPageStateService.setFindOrderFormValue(event.target.value);
    this.searchOrder(true);
  }

  inp_group(controlName: any) {
    return this.findOrderForm.controls[controlName];
  }

  closePannel() {
    let patchSandboxSourceData = { hideSideMenu: 'Yes', widthMainMenu: 'width70' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  ngOnDestroy() {
    let patchSandboxSourceData = { findOrderFormValue: this.findOrderForm.value.pnrNumber };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
}
